<template>
    <div class="mx-auto">
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <page-title :title="$t('activity.title')" :showTitle="false"></page-title>

            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-primary"
                        @click="backToRegister">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>

            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('activity.information') }}</div>
                </div>
                <div class="card-body">
                    <div class="row mt-2">
                        <div class="form-group col-12">
                            <label class="font-weight-bold required">{{ $t('activity.activity') }}</label>
                            <input type="text" class="form-control mt-1"
                                   readonly
                                   v-model="activity.type" />
                        </div>
                    </div>
                    <div class="row mt-2" v-if="activity.subType1">
                        <div class="form-group col-12">
                            <label class="font-weight-bold required">{{ $t('activity.subActivity') }}</label>
                            <input type="text" class="form-control mt-1"
                                   readonly
                                   v-model="activity.subType1" />
                        </div>
                    </div>
                    <div class="row mt-2" v-if="activity.subType2">
                        <div class="form-group col-12">
                            <label class="font-weight-bold required">{{ $t('activity.direction') }}</label>
                            <input type="text" class="form-control mt-1"
                                   readonly
                                   v-model="activity.subType2" />
                        </div>
                    </div>
                    <div class="row mt-2" v-if="activity.subType3">
                        <div class="form-group col-12">
                            <label class="font-weight-bold required">{{ $t('activity.subDirection') }}</label>
                            <input type="text" class="form-control mt-1"
                                   readonly
                                   v-model="activity.subType3" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-3" v-if="activity">
                <AuxiliaryRegisterDetails :entryId="activity.auxRegisterEntityId"></AuxiliaryRegisterDetails>
            </div>
        </div>
    </div>
</template>

<script>
    import { ActivityDetails } from '../../../models/models';
    import PageTitle from '../../../components/common/PageTitle';
    import AuxiliaryRegisterDetails from '../../../components/dynamic/AuxiliaryRegisterDetails'

    export default {
        components: {
            PageTitle,
            AuxiliaryRegisterDetails
        },
        props: {
            id: {
                type: Number,
                required: true
            },
            returnUrl: {
                type: String,
                default() {
                    return '';
                }
            }
        },
        data() {
            return {
                activity: new ActivityDetails(),
                loading: false,
            }
        },
        methods: {
            backToRegister() {
                this.$router.push(this.returnUrl || '/registers/activities');
            },
            loadData() {
                this.loading = true;
                this.$http.get(`/api/activity/GetDetails/${this.id}`).then(result => {
                    this.activity = new ActivityDetails(result.data);
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('buttons.load.btnText'),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }).then(() => { this.loading = false; });
            },
        },
        mounted() {
            this.loadData();
        }
    }
</script>

<style scoped>
     input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
